import { apiFetch } from '@ami/react/core';
import { CustomerApprovalOrderLookupViewModel } from '../orders/order';

const _baseEndPoint = 'customer-approvals/order-lookup';

const ordersLookupServices = {
  getOrderCustomerApproval: async (approvalRequestId) => {
    const url = `${_baseEndPoint}/${approvalRequestId}`;
    const entity = await apiFetch(url, 'GET', null, null, true);
    return new CustomerApprovalOrderLookupViewModel(entity);
  },
  customerApprovalsViewed: async (orderId, fullName) => {
    return apiFetch(
      `${_baseEndPoint}/${orderId}/customerApprovalsViewed`,
      'POST',
      { fullName: fullName },
      {
        automaticSuccessNotification: false,
      },
      true
    );
  },
};
export { ordersLookupServices };
